module.exports = __webpack_public_path__ + "img/expostyle_0915_mousy_grey_pantone429c.73ad968b.jpg";